/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { BaseController } from '../../BaseController';
import {Filter} from "../../../model/Filter";

class CauseViewController extends BaseController {
    /** @ngInject */
    constructor(configuration, causeService, domainService, originService, categoryService, attributeService,
                waitSpinnerService, $q, $state, $stateParams, $log, notificationService, filterService, dialogService) {
        super(configuration, notificationService, waitSpinnerService, $q, $state, $stateParams, $log);
        this.causeService = causeService;
        this.domainService = domainService;
        this.originService = originService;
        this.categoryService = categoryService;
        this.attributeService = attributeService;
        this.filterService = filterService;
        this.dialogService = dialogService;
        this.$log.debug('Controller \'CauseView\' loaded');
    }

    $onInit() {
        super.$onInit();

        this.waitSpinnerService.visible = true;
        this.formDisabled = false;
        this.domains = [];
        this.origins = [];
        this.categories = [];
        this.attributes = [];
        this.commands = [];

        // The updateMode flag can be used to know the context in which this controller is running: creation or update.
        let initPromise;
        let domainPromise;
        if (this.$stateParams.hasOwnProperty('id')) {
            this.updateMode = true;
            this.title = 'ui.cause.update';
            initPromise = this.causeService.getEntity(this.$stateParams.id);
            domainPromise = [];
        } else {
            this.updateMode = false;
            this.title = 'ui.cause.create';
            initPromise = {};
            domainPromise = this.domainService.findEntities({
                params: this.filterService.buildSortingParam({sort: 'name'})
            });
        }

        this.handleRestServiceCall(this.$q.all({
            entity: initPromise,
            domains: domainPromise
        }), data => {
            this.pristineEntity = data.entity;
            this.domains = data.domains;
            this.reset();
            this.initCommands();
        }).finally(() => {
            this.waitSpinnerService.visible = false;
        });
    }

    initOrigins(selectedDomain) {
        this.origin={};
        this.handleRestServiceCall(
            this.originService.findEntities({
                params: this.filterService.buildSortingParam({sort: 'code'}),
                data: this.filterService.buildFilters([
                    Filter.equalFilter('domain.id', selectedDomain, 'model.domain.domain')
                ])
            }), origins => {
            this.origins= origins;
        });
    }

    initCategories(selectedOrigin) {
        this.category={};
        this.handleRestServiceCall(
            this.categoryService.findEntities({
                params: this.filterService.buildSortingParam({sort: 'code'}),
                data: this.filterService.buildFilters([
                    Filter.equalFilter('origin.id', selectedOrigin, 'model.domain.domain')
                ])
            }), categories => {
            this.categories= categories;
        });
    }

    initAttributes(selectedCategory) {
        this.attribut={};
        this.handleRestServiceCall(
            this.attributeService.findEntities({
                params: this.filterService.buildSortingParam({sort: 'code'}),
                data: this.filterService.buildFilters([
                    Filter.equalFilter('category.id', selectedCategory, 'model.domain.domain')
                ])
            }), attributes => {
            this.attributes= attributes;
        });
    }

    /**
     * Initializes the commands available in the view header.
     */
    initCommands() {
        // No commands
    }

    save() {
        this.formDisabled = true;
        let serviceActionPromise;
        if (this.updateMode) {
            serviceActionPromise = this.causeService.updateEntity(this.cause);
        } else {
            serviceActionPromise = this.causeService.createEntity(this.cause);
        }
        this.handleRestServiceCall(serviceActionPromise, () => {
            const message = 'ui.cause.' + (this.updateMode ? 'updated' : 'created');
            this.notificationService.pushMessage(message, this.configuration.NOTIFIER_LEVEL_INFO);
            if (this.updateMode) {
                this.$state.reload();
            } else {
                this.$state.go('gmao.organization.cause.list');
            }
        }).finally(() => {
            this.formDisabled = false;
        });
    }

    reset() {
        this.cause = angular.copy(this.pristineEntity);
    }
}

export const causeViewComponent = {
    template: require('./cause-view.html'),
    controller: CauseViewController
};



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/organization/component/CauseView.js